/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:30 GMT
 */
const tokens = {
    component: {
        statusIndicator: {
            height: {
                value: "24px",
                type: "dimension",
            },
            paddingTop: {
                value: "4px",
                type: "dimension",
            },
            paddingRight: {
                value: "12px",
                type: "dimension",
            },
            paddingBottom: {
                value: "4px",
                type: "dimension",
            },
            paddingLeft: {
                value: "12px",
                type: "dimension",
            },
            gap: {
                value: "4px",
                type: "dimension",
            },
            borderRadius: {
                value: "9999px",
                type: "dimension",
            },
            label: {
                fontSize: {
                    value: "0.75rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 600,
                    type: "number",
                },
                lineHeight: {
                    value: "1rem",
                    type: "dimension",
                },
                letterSpacing: {
                    value: "0.3px",
                    type: "dimension",
                },
            },
            colors: {
                warning: {
                    backgroundColor: {
                        value: "#fee400",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                success: {
                    backgroundColor: {
                        value: "#8ee400",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                error: {
                    backgroundColor: {
                        value: "#930012",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                notification: {
                    backgroundColor: {
                        value: "#1dd9f9",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                disabled: {
                    backgroundColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
            },
            withIcon: {
                paddingLeft: {
                    value: "4px",
                    type: "dimension",
                },
            },
            iconOnly: {
                paddingLeft: {
                    value: "2px",
                    type: "dimension",
                },
                paddingRight: {
                    value: "2px",
                    type: "dimension",
                },
            },
            icon: {
                width: {
                    value: "20px",
                    type: "dimension",
                },
                height: {
                    value: "20px",
                    type: "dimension",
                },
            },
            sequential: {
                imminent: {
                    backgroundColor: {
                        value: "#e6005c",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                critical: {
                    backgroundColor: {
                        value: "#ff66a3",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                veryHigh: {
                    backgroundColor: {
                        value: "#ff99c4",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                high: {
                    backgroundColor: {
                        value: "#ffcce1",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                medium: {
                    backgroundColor: {
                        value: "#f4eb75",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                lowMedium: {
                    backgroundColor: {
                        value: "#fef9af",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                low: {
                    backgroundColor: {
                        value: "#9ef5ee",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                veryLow: {
                    backgroundColor: {
                        value: "#00e5d2",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                minor: {
                    backgroundColor: {
                        value: "#00ccbb",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                doubtful: {
                    backgroundColor: {
                        value: "#00a89a",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
            },
            qualitative: {
                blue1: {
                    backgroundColor: {
                        value: "#00d3f3",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                blue2: {
                    backgroundColor: {
                        value: "#00aaf3",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                blue3: {
                    backgroundColor: {
                        value: "#0086fa",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                blue4: {
                    backgroundColor: {
                        value: "#0b4cce",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                purple1: {
                    backgroundColor: {
                        value: "#c247fa",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                purple2: {
                    backgroundColor: {
                        value: "#8b4bfa",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                purple3: {
                    backgroundColor: {
                        value: "#642fcf",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                purple4: {
                    backgroundColor: {
                        value: "#4d1dd5",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                gray1: {
                    backgroundColor: {
                        value: "#dadada",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                gray2: {
                    backgroundColor: {
                        value: "#a0a2a5",
                        type: "color",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                gray3: {
                    backgroundColor: {
                        value: "#6f7377",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                gray4: {
                    backgroundColor: {
                        value: "#282e37",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
            },
            severityIndicator: {
                gap: {
                    value: "8px",
                    type: "dimension",
                },
                badge: {
                    width: {
                        value: "12px",
                        type: "dimension",
                    },
                    height: {
                        value: "12px",
                        type: "dimension",
                    },
                    borderRadius: {
                        value: "2px",
                        type: "dimension",
                    },
                    imminent: {
                        backgroundColor: {
                            value: "#a30041",
                            type: "color",
                        },
                    },
                    critical: {
                        backgroundColor: {
                            value: "#e6005c",
                            type: "color",
                        },
                    },
                    veryHigh: {
                        backgroundColor: {
                            value: "#ff66a3",
                            type: "color",
                        },
                    },
                    high: {
                        backgroundColor: {
                            value: "#ff99c4",
                            type: "color",
                        },
                    },
                    medium: {
                        backgroundColor: {
                            value: "#f5cc00",
                            type: "color",
                        },
                    },
                    lowMedium: {
                        backgroundColor: {
                            value: "#f4eb75",
                            type: "color",
                        },
                    },
                    low: {
                        backgroundColor: {
                            value: "#00e5d2",
                            type: "color",
                        },
                    },
                    veryLow: {
                        backgroundColor: {
                            value: "#00ccbb",
                            type: "color",
                        },
                    },
                    minor: {
                        backgroundColor: {
                            value: "#00a89a",
                            type: "color",
                        },
                    },
                    doubtful: {
                        backgroundColor: {
                            value: "#00a89a",
                            type: "color",
                        },
                    },
                },
                label: {
                    fontSize: {
                        value: "0.75rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 600,
                        type: "number",
                    },
                    lineHeight: {
                        value: "1rem",
                        type: "dimension",
                    },
                    letterSpacing: {
                        value: "0.3px",
                        type: "dimension",
                    },
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
            },
        },
    },
};
export default tokens;
